exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* stylelint-disable */\n\n/* ==========================================================================\n   Password Generator\n   ========================================================================== */\n.password-generator .input-addon--suffix {\n  padding-right: 5px; }\n\n.password-generator--custom-validation {\n  background-color: #fff; }\n  .password-generator--custom-validation .validation {\n    background: #fff;\n    border: 1px solid transparent;\n    color: #363636;\n    font-size: 14px; }\n  .password-generator--custom-validation .validation--success {\n    border-color: #6acb4c; }\n  .password-generator--custom-validation .validation--error {\n    border-color: #f54545; }\n  .password-generator--custom-validation .validation--warning {\n    border-color: #eca03e; }\n  .password-generator--custom-validation .validation--hint {\n    border-color: #a4a4a4; }\n\n/* Hits wrapper\n   ========================================================================== */\n.password-generator__hints {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0; }\n\n.password-generator__hints--weak .password-generator__strength-meter {\n  background: #f54545; }\n\n.password-generator__hints--good .password-generator__strength-meter {\n  background: #eca03e; }\n\n.password-generator__hints--strong .password-generator__strength-meter {\n  background: #6acb4c; }\n\n/* Password Strength Meter\n   ========================================================================== */\n.password-generator__strength-meter-wrapper {\n  height: 2px;\n  background-color: #ddd; }\n\n.password-generator__strength-meter {\n  height: 2px;\n  max-width: 100%; }\n\n/* Hit row\n   ========================================================================== */\n.password-generator__hint {\n  padding: 10px 0; }\n\n.password-generator__hint-icon {\n  margin-right: 5px; }\n\n.password-generator__hint-icon--success {\n  color: #6acb4c; }\n\n.password-generator__hint-icon--error {\n  color: #f54545; }\n\n.password-generator__hint-icon--warning {\n  color: #eca03e; }\n\n/* Suffix Buttons\n   ========================================================================== */\n.password-generator__suffix {\n  display: flex;\n  align-items: center; }\n  .password-generator__suffix .icon-button + .button {\n    margin-left: 5px; }\n  .password-generator__suffix .button + .button {\n    margin-left: 5px; }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};